const r={primary:"primary",secondary:"secondary",tertiary:"tertiary"},a={light:"light",fixed:"fixed"};var t=(e=>(e.Numerical="Numerical",e.Icon="Icon",e))(t||{});export{t as Types,a as themes,r as variants};
//# sourceMappingURL=badge.types.js.map
